module.exports = __webpack_public_path__ + "a3ef1ae9516c6d401597f9deca97035d.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/smash-icon.png
// module id = 1733
// module chunks = 0